import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import { Stat } from '../types';

interface StatsSectionProps {
  stats: Stat[];
}

const StatsSection = ({ stats }: StatsSectionProps) => {
  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, delay: 0.8 }}
      className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl mx-auto"
    >
      {stats.map((stat, index) => (
        <motion.div
          key={stat.id}
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.9 + index * 0.15 }}
          whileHover={{ y: -6, transition: { duration: 0.25 } }}
          className="glass-card rounded-2xl p-6 text-center"
        >
          <div className="w-12 h-12 rounded-full bg-accent/20 border border-accent/30 flex items-center justify-center mx-auto mb-4">
            <Icon name={stat.iconName} size={22} color="var(--color-accent)" />
          </div>
          <div className="text-3xl font-bold text-white mb-2 glow-text">{stat.value}</div>
          <div className="text-sm text-white/60">{stat.label}</div>
        </motion.div>
      ))}
    </motion.div>
  );
};

export default StatsSection;